import { useEffect, useState } from "react";

import api from "../../../api";
import { VatSubmissionEntry } from "../../../types";
import { ContentWrapper } from "../../common/styledComponents";
import useEmailParam from "../../hooks/useEmailParam";
import VatSubmissionsTable from "./VatTable/VatDeclarationDetails/VatSubmissionsTable";
import { Fieldset, Legend } from "./styledComponents";
import SubNavigation, { VAT_TABS } from "./SubNavigation";
import CustomerSearchInput from "@/lib/customerSearch/CustomerSearchInput";

const VatSubmissionsView = () => {
  const [email, setEmail] = useEmailParam();

  const [submissions, setSubmissions] = useState<VatSubmissionEntry[] | null>(
    null
  );
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!email) {
      setSubmissions(null);
      return;
    }

    setLoading(true);
    setError(null);

    api.kontax
      .getVatSubmissionList(email)
      .then((data) => setSubmissions(data))
      .catch((err) => setError(err?.message ?? "Failed to load data"))
      .finally(() => setLoading(false));
  }, [email]);

  return (
    <ContentWrapper>
      <SubNavigation activeTab={VAT_TABS.SUBMISSIONS.key} />
      <Fieldset>
        <Legend>VAT Submissions</Legend>
        {/* Searches on Enter / Filter, not on every keystroke, so the
            input is resolved once to the customer's email (SMT-1396). */}
        <CustomerSearchInput
          value={email}
          onSelect={setEmail}
          style={{ maxWidth: 400, marginBottom: 16 }}
        />
        {error && <p style={{ color: "red" }}>{error}</p>}
        {!email && <p>Search for a customer to see their VAT submissions</p>}
        {email &&
          !loading &&
          submissions !== null &&
          submissions.length === 0 && (
            <p>No VAT submissions found for this email</p>
          )}
        {email && submissions !== null && submissions.length > 0 && (
          <VatSubmissionsTable submissions={submissions} email={email} />
        )}
      </Fieldset>
    </ContentWrapper>
  );
};

export default VatSubmissionsView;
